<template>
  <div-box :src="require('../../assets/img/jeidian_bg@2x.png')" padding='3vw'>
    <wallet-head show_type="6" />
    <div-card padding="22vw 0 0 10vw" height="45vw">
      <div-text color='#CEB082' bold size='6vw'>{{ info.bonus_total }}</div-text>
      <div-text color='#fff' size='4vw'>{{ $t('当前系统分红节点') }}</div-text>
    </div-card>
    <div-padding padding="4vw">
      <div-flex>
        <div-flex left>
          <div-img width='4vw' height='4vw'>
            <img src="../../assets/img/zujian@2x.png" alt="">
          </div-img>
          <div-width width='1vw' />
          <div-text color='#fff' size='4vw'>{{ $t('我的节点') }}</div-text>
        </div-flex>
        <div-flex right @click="router('jd_list')">
          <div-text color='#999999' size='4vw'>{{ $t('节点记录') }}</div-text>
          <div-width width='1vw' />
          <van-icon color='#999' name='arrow' />
        </div-flex>
      </div-flex>
      <div-height height='3vw' />
      <div-card bg='#242424' padding='3vw'>
        <div-flex>
          <div-text color='#fff' size='4vw'>{{ $t('节点数量') }}</div-text>
          <div-text color='#CEB082' bold size='4.5vw'>{{ info.bonus_radio }}</div-text>
        </div-flex>
      </div-card>
    </div-padding>
    <div-padding padding="0 4vw">
      <div-flex left>
        <div-img width='4vw' height='4vw'>
          <img src="../../assets/img/zujian@2x.png" alt="">
        </div-img>
        <div-width width='1vw' />
        <div-text color='#fff' size='4vw'>{{ $t('节点排名') }}</div-text>
      </div-flex>
    </div-padding>
    <div-padding padding="4vw">
      <div-card bg='#242424' padding='3vw'>
        <div-flex>
          <div-width width='17vw'>
            <div-text color='#999' align="center" size='4vw'>{{ $t('名次') }}</div-text>
          </div-width>
          <div-width width='30vw'>
            <div-text color='#999' align="center" size='4vw'>{{ $t('数量') }}</div-text>
          </div-width>
          <div-width width='30vw'>
            <div-text color='#999' align="right" size='4vw'>{{ $t('地址') }}</div-text>
          </div-width>
        </div-flex>
        <!-- <div-height height='3vw' /> -->
        <div-flex height="8vw" v-for="(item, index) in info.list" :key="index">
          <div-width width='17vw'>
            <div-img width='11vw' margin="0 auto" height='5vw' v-if="index == 0">
              <img src="../../assets/img/1@2x.png" alt="">
            </div-img>
            <div-img width='5vw' margin="0 auto" height='5vw' v-if="index == 1">
              <img src="../../assets/img/2@2x.png" alt="">
            </div-img>
            <div-img width='5vw' margin="0 auto" height='5vw' v-if="index == 2">
              <img src="../../assets/img/3@2x.png" alt="">
            </div-img>
            <div-text color='#999' align="center" size='4vw' v-if="index > 2">{{ index }}</div-text>
          </div-width>
          <div-width width='30vw'>
            <div-text color='#CEB082' align="center" size='4vw'>{{ item.bonus_radio }}</div-text>
          </div-width>
          <div-width width='30vw'>
            <div-text color='#999' align="right" size='4vw'>{{ addressFun(item.account) }}</div-text>
          </div-width>
        </div-flex>
      </div-card>
    </div-padding>
  </div-box>
</template>

<script>
  export default {
    data() {
      return {
        activex: 0,
        info: {},
      }
    },
    created() {
      this.getdata()
    },
    methods: {
      getdata() {
        this.$get({
          url: "/api/v1/user/rank",
          success: (res) => {
            this.info = res.data
          },
          tip: () => { },
        })
      },
    },
  }
</script>
<style lang='less' scoped></style>